import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { GeckoBtn, GECKO_CONSTS } from 'ui';
import GeckoLocation from 'services/gecko-location';

class RecurringImportDetails extends Component {
  static propTypes = {
    syncRecord: PropTypes.object,
  };

  static defaultProps = {
    showProgress: true,
  };

  progressClasses = {
    'in progress': 'in-progress',
    completed: 'completed',
    failed: 'failed',
    new: 'in-progress',
  };

  showFailedImports() {
    GeckoLocation.goTo(
      `/settings/integrations/import-failures/${this.props.syncRecord.id}`
    );
  }

  render() {
    if (!this.props.syncRecord) {
      return (
        <div className="RecurringImportDetails">
          <span>Last Sync: Never</span>
        </div>
      );
    }
    const { sync_status, createdAt } = this.props.syncRecord;
    const {
      total = ' - ',
      completed = ' - ',
      failed = ' - ',
      progress,
    } = this.props.syncRecord.metadata;
    return (
      <div
        className={`RecurringImportDetails ${
          this.progressClasses[Number(failed) > 0 ? 'failed' : sync_status]
        }`}
      >
        <span>
          Last Sync: {moment(createdAt).format('DD/MM/YYYY HH:mm')}
          {sync_status === 'in progress' || sync_status === 'new'
            ? '(In progress)'
            : ''}
        </span>
        <br />
        <span>Total: {total}</span>
        <br />
        <span>Completed: {completed}</span>
        <br />
        <span>Failed: {failed}</span>
        <br />
        {this.props.showProgress ? (
          <span>
            Progress: {progress ? `${progress}%` : ' - '}
            <br />
          </span>
        ) : null}
        {Number(failed) > 0 ? (
          <GeckoBtn
            name="View Failed Imports"
            icon="far fa-eye"
            type={GECKO_CONSTS.BTN_TYPE_DEFAULT}
            handler={this.showFailedImports.bind(this)}
          />
        ) : null}
      </div>
    );
  }
}

export default RecurringImportDetails;
